export default "__VITE_ASSET__BoXTuML7__"